var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "876.000000pt",
    height: "573.000000pt",
    viewBox: "0 0 876.000000 573.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,573.000000) scale(0.100000,-0.100000)",
    fill: "#1857a2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723 5313 c-398 -230 -719 -420 -715 -424 15 -15 1432 -829 1442 -829 6 0 10 70 10 205 l0 206 1813 -3 1812 -3 77 -22 c158 -45 258 -115 336 -235 134 -206 145 -480 29 -717 -44 -91 -151 -198 -242 -244 -154 -77 -51 -71 -1295 -78 -1209 -6 -1168 -4 -1321 -62 -179 -68 -282 -188 -341 -402 l-23 -80 -3 -1072 -3 -1073 426 0 425 0 2 905 3 905 28 27 27 28 657 0 657 0 348 -590 c571 -967 555 -941 626 -1016 105 -112 227 -173 434 -218 150 -32 330 -41 876 -41 l502 0 0 -240 c0 -132 3 -240 8 -240 16 1 1434 826 1434 835 1 9 -1418 835 -1434 835 -5 0 -8 -108 -8 -241 l0 -240 -507 3 c-594 4 -579 2 -673 96 -59 60 -61 64 -464 757 l-215 369 102 36 c254 90 461 241 618 453 384 515 397 1377 28 1867 -191 254 -502 440 -848 510 -196 39 -264 40 -2103 40 l-1788 0 0 205 c0 113 -3 205 -7 205 -5 0 -333 -188 -730 -417z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.09daecce4c4fcd6be42c8568bc816757.svg";
export { ForwardRef as ReactComponent };